import { ArrowDownLeft, ArrowUpRight, CalendarClock, Gift, Lock } from 'lucide-react'

import {
  PRICE_ADJUSTMENT_PRIORITY_HIGH,
  PRICE_ADJUSTMENT_PRIORITY_NORMAL,
  PRICE_ADJUSTMENT_ROUNDING_NEAREST_DOLLAR,
  PRICE_ADJUSTMENT_ROUNDING_NEAREST_HALF_DOLLAR,
  PRICE_ADJUSTMENT_ROUNDING_NONE,
  PRICE_ADJUSTMENT_START_TYPE_FIXED_DATE,
  PRICE_ADJUSTMENT_START_TYPE_HOLIDAY_OFFSET,
  PRICE_ADJUSTMENT_WHEN_TYPE_ACTIVE_UNTIL_DELETED,
  PRICE_ADJUSTMENT_WHEN_TYPE_PERMANENT,
  PRICE_ADJUSTMENT_WHEN_TYPE_SCHEDULED,
} from '@/lib/services/price-adjustments/priceAdjustments.schema'

export const adjustmentTypeOptions = [
  { id: 'percent', name: '%' },
  { id: 'flat', name: '$' },
]

export const operationOptions = [
  {
    id: 'increase',
    name: 'Increase',
    selectedTone: 'success',
    start: (
      <span className="inline-flex items-center" aria-hidden="true">
        <ArrowUpRight className="size-3.5" />
      </span>
    ),
  },
  {
    id: 'decrease',
    name: 'Decrease',
    selectedTone: 'destructive',
    start: (
      <span className="inline-flex items-center" aria-hidden="true">
        <ArrowDownLeft className="size-3.5" />
      </span>
    ),
  },
]

export const roundingOptions = [
  { id: PRICE_ADJUSTMENT_ROUNDING_NONE, name: 'None' },
  {
    id: PRICE_ADJUSTMENT_ROUNDING_NEAREST_HALF_DOLLAR,
    name: 'Nearest $0.50',
  },
  {
    id: PRICE_ADJUSTMENT_ROUNDING_NEAREST_DOLLAR,
    name: 'Nearest $1.00',
  },
]

export const priorityOptions = [
  { id: PRICE_ADJUSTMENT_PRIORITY_NORMAL, name: 'Normal' },
  { id: PRICE_ADJUSTMENT_PRIORITY_HIGH, name: 'Priority' },
]

export const whenTypeOptions = [
  { id: PRICE_ADJUSTMENT_WHEN_TYPE_ACTIVE_UNTIL_DELETED, name: 'Active until deleted' },
  { id: PRICE_ADJUSTMENT_WHEN_TYPE_SCHEDULED, name: 'Scheduled' },
  {
    id: PRICE_ADJUSTMENT_WHEN_TYPE_PERMANENT,
    name: 'Permanent',
    selectedTone: 'destructive',
  },
]

export const scheduleStartTypeOptions = [
  { id: PRICE_ADJUSTMENT_START_TYPE_HOLIDAY_OFFSET, name: 'Holiday' },
  { id: PRICE_ADJUSTMENT_START_TYPE_FIXED_DATE, name: 'Specific date' },
]

const showPageSelectorIconClass =
  'mt-0.5 shrink-0 rounded-xl border border-current/15 bg-background/80 p-2 shadow-sm'

export const showPageWhenTypeOptions = [
  {
    id: PRICE_ADJUSTMENT_WHEN_TYPE_ACTIVE_UNTIL_DELETED,
    name: 'Active until deleted',
    start: (
      <span className={`${showPageSelectorIconClass} text-chart-5`} aria-hidden="true">
        <CalendarClock className="size-5" />
      </span>
    ),
  },
  {
    id: PRICE_ADJUSTMENT_WHEN_TYPE_SCHEDULED,
    name: 'Scheduled',
    start: (
      <span className={`${showPageSelectorIconClass} text-chart-1`} aria-hidden="true">
        <Gift className="size-5" />
      </span>
    ),
  },
  {
    id: PRICE_ADJUSTMENT_WHEN_TYPE_PERMANENT,
    name: 'Permanent',
    selectedTone: 'destructive',
    start: (
      <span
        className={`${showPageSelectorIconClass} text-status-destructive-foreground`}
        aria-hidden="true"
      >
        <Lock className="size-5" />
      </span>
    ),
  },
]

export const showPageCardClass = 'gap-0 overflow-hidden py-0'
export const showPageIncreaseIconShellClass = 'bg-chart-3/10 text-chart-3 ring-chart-3/40'
export const showPageDecreaseIconShellClass = 'bg-chart-1/10 text-chart-1 ring-chart-1/40'
export const showPageScheduleIconClass = 'bg-chart-1/10 text-chart-1 ring-chart-1/40'
export const showPageIconShellClass =
  'flex size-10 shrink-0 items-center justify-center rounded-xl bg-muted/45 ring-1 ring-inset ring-border/20 dark:bg-background/30 dark:ring-white/10'
